import {
  ChapterQuery,
  ChapterQueryVariables,
  FETCH_CHAPTER_BY_MISSION_SLUG_AND_CHAPTER_TITLE,
  Mission,
} from '@edwin-group/cj-graphql';
import { useSuspenseQuery } from '@apollo/client';
import { useEffect } from 'react';
import { useChapterStore } from '../store/useChapterStore';
import { useMission } from './useMission';
import { useMissionRouteParams } from './useMissionRouteParams';
import { trackGAEventOnceExpiresIn5Minutes } from '@/lib/ga-custom-events/dispatcher';

export const useChapter = () => {
  const { missionSlug, chapterTitle } = useMissionRouteParams();
  const { missionResult } = useMission();
  const setChapter = useChapterStore((state) => state.setChapter);
  const chapter = useChapterStore((state) => state.chapter);

  const { data: chapterResult, error: chapterError } = useSuspenseQuery<ChapterQuery, ChapterQueryVariables>(
    FETCH_CHAPTER_BY_MISSION_SLUG_AND_CHAPTER_TITLE,
    {
      variables: {
        slug: missionSlug!,
        title: chapterTitle!,
      },
      fetchPolicy: 'cache-and-network',
    },
  );

  useEffect(() => {
    setChapter(chapterResult, missionResult.fetchMissionBySlugAndSchoolAndSchoolYear as Mission);
  }, [chapterResult, missionResult, setChapter]);

  useEffect(() => {
    if (chapter && missionResult?.fetchMissionBySlugAndSchoolAndSchoolYear) {
      trackGAEventOnceExpiresIn5Minutes(
        'chapter_completed',
        {
          mission_name: missionResult.fetchMissionBySlugAndSchoolAndSchoolYear?.roleModel ?? '',
          mission_document_id: missionResult.fetchMissionBySlugAndSchoolAndSchoolYear?.documentId ?? '',
          chapter_name: chapter.title ?? '',
        },
        [chapter.title ?? chapter.uuid ?? ''],
      );
    }
  }, [chapter, missionResult?.fetchMissionBySlugAndSchoolAndSchoolYear]);

  return {
    missionResult,
    errors: [chapterError].filter(Boolean),
  };
};
